import React from 'react';
import { StyleSheet } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import StackNavigator from './src/navigation/StackNavigator';
import { linking } from './src/navigation/linking';

function App() {
  return (
    <SafeAreaProvider>
      <GestureHandlerRootView style={styles.root}>
        {/* linking is only defined on web; on Android/iOS the navigator
            stays in-memory (see src/navigation/linking.ts). */}
        {/* React Navigation writes document.title from the focused route's
            name/options on web by default, which would replace the SEO title
            with e.g. "Map". The app controls the browser metadata itself via
            usePageMeta (src/utils/pageMeta.web.ts), so opt out here. The prop
            is inert on Android/iOS (useDocumentTitle is a no-op there). */}
        <NavigationContainer linking={linking} documentTitle={{ enabled: false }}>
          <StackNavigator />
        </NavigationContainer>
      </GestureHandlerRootView>
    </SafeAreaProvider>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
});

export default App;